import Service from '@ember/service';

import { service } from '@ember/service';

import strings from 'rise-ui/config/strings.js';
import { joinKeywords } from 'rise-ui/utils/keywords.js';

export default class KeywordsService extends Service {
  @service catalogThemes;

  /**
   * Note: headTags doesn't support responsiveness, so we need to make sure
   * that all common keyword data is loaded before they are applied. For that
   * reason, this method should be called and awaited in the application route.
   */
  async load() {
    await this.catalogThemes.getThemes();
  }

  get themes() {
    return this.catalogThemes.themes;
  }

  /**
   *
   * @param {boolean} includeThemes
   * @param keywords
   * @returns {string}
   */
  keywords(includeThemes = false, ...keywords) {
    return this.joinKeywords(
      strings['base-keywords'],
      includeThemes ? this.themes : null,
      ...keywords,
    );
  }

  joinKeywords = joinKeywords;

  strings = strings;
}
